import { ViewModel,View, ObservableArray } from "binder"
import  { TranslatorSelectionPopupView } from "./translatorSelectionPopup-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";

export class TranslatorSelectionPopupViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    
        this.processes = ObservableArray.create<process>();
        this.enums = ObservableArray.create<enums>();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set processes(v: ObservableArray<process>) { this._processes = v; } public get processes(): ObservableArray<process> { return this._processes;} private _processes: ObservableArray<process>;
    public set enums(v: ObservableArray<enums>) { this._enums = v; } public get enums(): ObservableArray<enums> { return this._enums;} private _enums: ObservableArray<enums>;
    public set selectedProcess(v: process) { 
        this._selectedProcess = v; 
        if(v){
            this.enums.update(...v.enums);
        }else{
            this.enums.clear();
        }
    } public get selectedProcess(): process { return this._selectedProcess;} private _selectedProcess: process;
    public set selectedEnum(v: enums) { this._selectedEnum = v; } public get selectedEnum(): enums { return this._selectedEnum;} private _selectedEnum: enums;
    
    GetDefaultView(): View <ViewModel> {
        return new TranslatorSelectionPopupView();
    }
    public getTypeId(): string {
        return "VM-A6DDB4FC-3A87-481D-8A01-CE42FDC9CBB0"
    }
    closePopup(result?: any) {
    }

    async loadData(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetAllEnumerationsInProcesses',{});
            this.processes.update(...result.Processes.map(x=>{
                let r = new process(this);
                r.id = x.ProcessId;
                r.name = x.Name;
                r.enums.update(...x.Enums.map(q=>{
                    let e = new enums(r);
                    e.name = q.Name;
                    return e
                }));
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    loadInfo(json:string){
        try{
            let parsed = JSON.parse(json);
            this.selectedProcess = this.processes.filter(x=>x.id==parsed.processId).at(0);
            this.selectedEnum = this.enums.filter(x=>x.name==parsed.enumName).at(0);
        }catch{}
    }
    confirm(){
        if(this.selectedProcess==null || this.selectedEnum==null)
            this.closePopup('');
        else{
            let result = JSON.stringify({
                processId : this.selectedProcess.id,
                processName : this.selectedProcess.name,
                enumName : this.selectedEnum.name
            });
            this.closePopup(result);
        }
    }
    back(){
        this.closePopup(null);
    }
}


export class process extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.enums = ObservableArray.create<enums>();
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set enums(v: ObservableArray<enums>) { this._enums = v; } public get enums(): ObservableArray<enums> { return this._enums;} private _enums: ObservableArray<enums>;
        
}

export class enums extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}